var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletconnect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.12101 2.99351C9.19672 -0.997838 15.8033 -0.997838 19.8843 2.99351L20.3746 3.47332C20.5802 3.67368 20.5802 3.99531 20.3746 4.19567L18.6979 5.84071C18.5978 5.94089 18.429 5.94089 18.3288 5.84071L17.654 5.18164C14.812 2.39771 10.1985 2.39771 7.35658 5.18164L6.63424 5.88817C6.53406 5.98835 6.36534 5.98835 6.26516 5.88817L4.5832 4.24312C4.37757 4.04276 4.37757 3.72113 4.5832 3.52077L5.12101 2.99351ZM23.3536 6.38906L24.8458 7.84957C25.0514 8.04993 25.0514 8.37156 24.8458 8.57192L18.1127 15.1679C17.907 15.3683 17.5801 15.3683 17.3745 15.1679L12.5923 10.4859C12.5395 10.4384 12.4605 10.4384 12.4077 10.4859L7.63076 15.1679C7.42513 15.3683 7.09823 15.3683 6.8926 15.1679L0.154223 8.57719C-0.0514078 8.37683 -0.0514078 8.0552 0.154223 7.85485L1.64637 6.39434C1.852 6.19398 2.1789 6.19398 2.38453 6.39434L7.16677 11.0764C7.2195 11.1239 7.29859 11.1239 7.35131 11.0764L12.1283 6.39434C12.3339 6.19398 12.6608 6.19398 12.8664 6.39434L17.6487 11.0764C17.7014 11.1239 17.7805 11.1239 17.8332 11.0764L22.6155 6.39434C22.8158 6.18871 23.148 6.18871 23.3536 6.38906Z",
    fill: "#3A99FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.d85ceee3afc51984fa6a22f9c6c71797.svg";
export { ForwardRef as ReactComponent };